import { computeDimensions } from "../image.helper";

import {
    ImageBackground,
    ImageFit,
    ImageSpecialBackground,
} from "../image.types";

import {
    Scene7FitWithUpscale,
    Scene7ImageLoaderParams,
} from "./scene7-image-loader.model";
import { Scene7ImageSettings } from "./scene7-image-settings";
import {
    SCENE7_IMAGE_BACKGROUND_DEFAULT,
    SCENE7_IMAGE_BACKGROUND_TRANSPARENT_THUMBNAIL,
} from "./scene7.constants";

export function buildScene7FitParameter(
    fit: ImageFit,
    upscale?: boolean,
): Scene7FitWithUpscale {
    return upscale ? `${fit},1` : fit;
}

export function isSpecialScene7BackgroundURLParameter(
    background: ImageBackground | undefined,
): background is ImageSpecialBackground {
    return background === "auto" || background === "transparent";
}

export function getSpecialScene7BackgroundURLParameter(
    background: ImageSpecialBackground,
) {
    switch (background) {
        case "auto": {
            return SCENE7_IMAGE_BACKGROUND_DEFAULT;
        }
        case "transparent": {
            return SCENE7_IMAGE_BACKGROUND_TRANSPARENT_THUMBNAIL;
        }
    }
}

export function computeScene7SizeParameter(
    size: number,
    maxSize: number | undefined,
    scene7Limit: number,
): number {
    // Avoid dimension error due to Scene 7 limitations
    return Math.round(
        Math.min(size, maxSize ? Math.min(maxSize, scene7Limit) : scene7Limit),
    );
}

function isAbsoluteSource(source: string): boolean {
    return source.includes("://") || source.startsWith("/");
}

export function buildPath(
    source: string,
    { baseURL }: Scene7ImageSettings,
): URL {
    const { origin, pathname: basePath } = new URL(baseURL);
    const fullPath = isAbsoluteSource(source)
        ? source
        : `${basePath}/${source}`;

    return new URL(fullPath, origin);
}

export function computeScene7Dimensions(
    width: number | undefined,
    parameters: Scene7ImageLoaderParams,
    settings: Scene7ImageSettings,
): { width?: number; height?: number } {
    const { width: computedWidth, height: computedHeight } = computeDimensions(
        width,
        parameters.height,
        parameters.aspectRatio,
    );

    return {
        width: computedWidth
            ? computeScene7SizeParameter(
                  computedWidth,
                  parameters.maxWidth,
                  settings.maxWidth,
              )
            : undefined,
        height: computedHeight
            ? computeScene7SizeParameter(
                  computedHeight,
                  parameters.maxHeight,
                  settings.maxHeight,
              )
            : undefined,
    };
}
